import { FC } from "react";

import { useNameFromPageAccessId } from "../../page/helpers";

import { ACCESS_ID_QUERY_PARAM } from "components/constants";
import { t } from "i18n/i18n";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { useCapabilities } from "store/capability-hooks";
import { useAppSelector } from "store/index";
import {
  selectCurrentPage,
  selectCurrentUserId,
  selectIsPracticeClassSession,
} from "store/selectors";
import { presentSession, setPresentationWindow, usePresentation } from "utils/presentation";
import { useQueryParamsManager } from "utils/routing";

interface FeatureResponsesButtonProps {
  className?: string;
}

export const FeatureResponsesButton: FC<FeatureResponsesButtonProps> = ({ className }) => {
  const userId = useAppSelector(selectCurrentUserId);
  const { canAuthorSection } = useCapabilities();
  const selectedPage = useAppSelector(selectCurrentPage);
  const { presentedPageId, unfeaturedTab, isPresenting, presentedSessionId } = usePresentation();
  const isPracticeClassSession = useAppSelector(selectIsPracticeClassSession);
  const { getQueryParam } = useQueryParamsManager();
  const selectedAccessId = getQueryParam(ACCESS_ID_QUERY_PARAM);
  const participantName = useNameFromPageAccessId(selectedAccessId, presentedPageId);

  if (
    !presentedSessionId ||
    !selectedPage ||
    !unfeaturedTab ||
    !presentedPageId ||
    !canAuthorSection ||
    !isPresenting
  ) {
    return null;
  }

  const onFeatureResponses = () => {
    setPresentationWindow();
    presentSession(presentedSessionId, {
      page: selectedPage,
      accessId: selectedAccessId,
      isRollup: true,
      isPractice: isPracticeClassSession,
      userId,
    });
  };

  return (
    <SquareButton
      className={className}
      eventName="Feature class responses"
      kind="complete"
      size="s"
      onClick={onFeatureResponses}
    >
      {participantName
        ? t("main_header.feature_status.feature_button_text", { name: participantName })
        : t("main_header.feature_status.feature_all_button_text")}
    </SquareButton>
  );
};
